import config from '../../config.js';
import products from '../../utils/products.js';
import fieldUtils from '../../utils/step.fields.utils.js';

const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`
        },
    ];
};

const drivers = (n) => {
    const result = [
        {...fieldUtils.driver_x_name(n)},
        {...fieldUtils.driver_x_date_of_birth(n)}
    ];

    if (n < config[products.van].drivers) {
        result.push({
            ...fieldUtils.driver_x_more(n),
            label: 'Are any additional drivers required on the policy?',
            children: drivers(n + 1),
            required_children: value => value === true
        });
    }
    return result;
};

const claims = (driver, n) => {
    const result = [
        {...fieldUtils.claim_x_type(driver, n)},
        {...fieldUtils.claim_x_date(driver, n)}
    ];

    if (n < config[products.van].claims) {
        result.push({
            ...fieldUtils.claim_x_more(driver, n),
            children: claims(driver, n + 1),
            required_children: value => value === true
        });
    }
    return result;
};
const convictions = (driver, n) => {
    const result = [
        {...fieldUtils.conviction_x_type(driver, n)},
        {...fieldUtils.conviction_x_points(driver, n)},
        {...fieldUtils.conviction_x_ban(driver, n)}
    ];

    if (n < config[products.van].mot_convictions) {
        result.push({
            ...fieldUtils.conviction_x_more(driver, n),
            children: convictions(driver, n + 1),
            required_children: value => value === true
        });
    }
    return result;
};
const modifications = (n) => {
    const result = [
        {...fieldUtils.modification_x_type(n)}
    ];

    if (n < config[products.van].vehicle_modifications) {
        result.push({
            ...fieldUtils.modification_x_more(n),
            children: modifications(n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const step_schema_van = [
    //source
    //Vehicle
    {
        key: 'vrm'
    },
    {
        key: 'make',
        required: true,
        skip_question: true,
    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        skip_question: true,
    },
    {
        key: 'body_type',
        value: ''
    },
    {
        key: 'value'
    },
    {
        key: 'impounded'
    },
    {
        key: 'owner',
        children: [
            {
                key: 'owner_since',
                required_if: parent_value => parent_value === true,
            },
        ],
    },
    {
        key: 'ncb_years_van'
    },
    {
        key: 'ncb_years_private'
    },
    {
        key: 'seats',
        value: 2,
    },
    {
        key: 'weight_over_35'
    },
    {
        key: 'business_use'
    },
    {
        key: 'driving_restriction'
    },
    {
        key: 'hire_vehicle_lease_use'
    },
    {
        key: 'personal_miles'
    },
    {
        key: 'has_modifications_more',
        children: modifications(0),
        required_children: value => value === true
    },
    {
        key: 'keeper'
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'uk_since',
        children: [
            {
                key: 'uk_since_date',
                required_if: parent_value => parent_value === false
            },
        ],
    },
    {
        key: 'licence_type'
    },
    {
        key: 'licence_date'
    },
    {
        key: 'occupation_waste_licence'
    },
    {
        key: 'employment_status',
        children: [
            {
                key: 'occupation_0_type',
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed'
            },
            {
                key: 'occupation_0_more',
                label: 'Do you have any additional occupation?',
                children: secondOccupation(),
                required_children: value => value === true,
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed'
            },
        ],
    },
    {
        key: 'has_convictions_more',
        label: 'Has the driver received any motoring convictions in the last 5 years?',
        children: convictions(`Proposer's`, 0),
        required_children: value => value === true
    },
    {
        key: 'has_claims_more',
        label: 'Has the driver any claims in the last 5 years?',
        children: claims('Proposer\'s', 0),
        required_children: value => value === true
    },
    {
        key: 'has_criminal_convictions'
    },
    {
        key: 'has_another_driver_more',
        label: 'Are any additional drivers required on the policy?',
        children: drivers(0),
        required_children: value => value === true
    },
    //policy
    {
        key: 'cover_date'
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_van;
